import { render, staticRenderFns } from "./RestrictedHeight.vue?vue&type=template&id=ce4aaf04"
import script from "./RestrictedHeight.vue?vue&type=script&lang=js"
export * from "./RestrictedHeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports